import { defaultHttpTimeoutMs } from '@core/constants';
import { OfferEventDto } from '@core/mappers/offer/dtos/OfferEventDto';
import { getCmsUrl } from '@core/services/cms/utils';
import { getConfig } from '@superbet-group/web.lib.config';
import {
    RestClient,
    createRestClient,
} from '@superbet-group/web.lib.rest';

type TopPriceBoostsResponse = { data: OfferEventDto[] };

class TopPriceBoostsService {
    private readonly restClient: RestClient = createRestClient(
        getCmsUrl({
            path: '',
        }),
        defaultHttpTimeoutMs,
    );

    public async getTopPriceBoosts(): Promise<OfferEventDto[]> {
        const country = getConfig().countrySpecific.country;
        const locale = getConfig().appLocale.locale;
        const date = new Date().toISOString().split('T')[0];

        const params = {
            target: country,
            locale,
            date,
        };

        const response = await this.restClient.get<TopPriceBoostsResponse>('top-price-boosts/v2', { params });
        return response.data;
    }
}

export default new TopPriceBoostsService();
